import { render } from "./WhatsAppTemplatesView.vue?vue&type=template&id=96cae1ba&scoped=true"
import script from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"
export * from "./WhatsAppTemplatesView.vue?vue&type=script&lang=js"

import "./WhatsAppTemplatesView.vue?vue&type=style&index=0&id=96cae1ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96cae1ba"]])

export default __exports__